export const API_URL = process.env.REACT_APP_BACKEND_URL
const endpoints = {
  // Auth
  BASE_API: API_URL + "/api/v1/",
  SIGN_IN: API_URL + "/api/v1/auth/signin",
  PROFILE: (params: any) => API_URL + `/api/v1/users/${params}`,
  FORGOT_PASSWORD: API_URL + "/api/v1/auth/forgot-password",
  RESET_PASSWORD: API_URL + "/api/v1/admin/reset-password",
  EDIT_PROFILE: (userId: any) => API_URL + `/api/v1/users/${userId}`,
  CHANGE_PASSWORD: API_URL + "/api/v1/users/change-password",

  // Role 
  VIEW_LIST_ROLE: API_URL + "/api/v1/role",

  // Area
  VIEW_LIST_AREA : API_URL + "/api/v1/area",

  // Blog
  BLOG : API_URL + "/api/v1/blog",

  BLOG_CONTENT : API_URL + "/api/v1/blog/content",

  // Facility
  VIEW_LIST_FACILITY : API_URL + "/api/v1/facility",

  // Audit Trail
  VIEW_LIST_AUDIT_TRAIL : API_URL + "/api/v1/audit-trail",

  // Icon
  ICON_LIST : API_URL + "/api/v1/icon",

  CLUSTER : API_URL + "/api/v1/cluster",

  //Property
  PROPERTY : API_URL + "/api/v1/property",
  PLACE : API_URL + "/api/v1/place",
  ROOM : API_URL + "/api/v1/room",
  UNIT : API_URL + "/api/v1/unit",

  //Survey
  SURVEY: API_URL + "/api/v1/survey",
  //Menu
  VIEW_LIST_MENU_BY_ROLE: (roleId: number) => API_URL + "/api/v1/menu/role/"+roleId,
  VIEW_LIST_MENU:  API_URL + "/api/v1/menu",

  // Users
  VIEW_LIST_USER: API_URL + "/api/v1/users",
  SEARCH_LIST_USER: API_URL + "/api/v1/admin/search-users",
  CREATE_USER: API_URL + "/api/v1/users",
  VIEW_USER: (viewId: any) => API_URL + `/api/v1/users/${viewId}`
};

export default endpoints;
